module.exports = __webpack_public_path__ + "static/media/java-icon.bc4aa275.png";